import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MsalHelperService {

  public alreadyInitialized: boolean = false;
  activeUser: string | undefined = 'unknown user';
  isAuthenticated = false;
  msalSubjects: Subscription;
  inProgressUpdates: Subscription;
  
  constructor(
    private readonly http: HttpClient,
    @Inject('BASE_URL') private readonly originUrl: string,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly msal: MsalService
  ) {}

  public runAfterAuthenticated(callback: () => any): void {
    //if MSAL login has already completed, just callback because we've already initialized the app
    if (this.alreadyInitialized) {
      callback();
    }
    else {
      this.msalBroadcastService.inProgress$.pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      ).subscribe({
        next: () => {
          const activeAccount = this.msal.instance.getActiveAccount();
          this.isAuthenticated = !!activeAccount;
          this.activeUser = activeAccount?.username;
          if (this.isAuthenticated) {
            this.alreadyInitialized = true;
            callback();
          }
        }
      });

      this.msalBroadcastService.msalSubject$.pipe(
        filter((message: EventMessage) => message.eventType === EventType.LOGIN_SUCCESS)
      ).subscribe({
        next: (message: EventMessage) => {
          const authResult = message.payload as AuthenticationResult;
          this.msal.instance.setActiveAccount(authResult.account);
        }
      });
    }
  }

  public updateLastLogin(): Observable<boolean> {
    return this.http.get<boolean>(this.originUrl + 'api/user/logindate');
  }
}
